import React, { useContext, useMemo } from "react";
import Select from "../../../../common/select";
import ConfigurationContext from "../../../../../infrastructure/context/configuration/configuration.context";
import IConfigurationContext from "../../../../../infrastructure/context/configuration/configuration.context.interface";

interface CountrySelectProps {
  countryLabel: string;
  inputId: string;
  onCountryChange: (countryCode: string) => void;
}

const CountrySelect: React.FC<CountrySelectProps> = ({
  countryLabel,
  inputId,
  onCountryChange,
}) => {
  const configurationContext =
    useContext<IConfigurationContext>(ConfigurationContext);

  let options: {
    valueAttribute: string;
    valueTranslated: string;
  }[] = useMemo(() => {
    const { supportedCountries } = configurationContext;

    return Object.entries(supportedCountries).map(([key, value]) => ({
      valueAttribute: key,
      valueTranslated: value as string,
    }));
  }, [configurationContext]);

  const initialSelectedOption =
    options.length > 0 ? options[0].valueAttribute : "";

  return (
    <li className="select-container">
      <Select
        name={inputId}
        label={countryLabel}
        id={inputId}
        title={countryLabel}
        isRequired={true}
        additionalClassName="billing-country-wr"
        options={options}
        selectedOption={initialSelectedOption}
        onSelectionChange={onCountryChange}
      />
    </li>
  );
};

export default CountrySelect;
